import React from "react";
import { IMenuItem } from "@venuepos/react-common";
import { ScrollView } from "react-native";
import { StyleFunction, useThemedStyle } from "@venuepos/react-common";

export function AdminContainer({
    children,
    testID,
}: {
    children: React.ReactNode;
    extraMenuItems?: IMenuItem[];
    testID?: string;
}) {
    const styles = useThemedStyle(styleFunc);

    return (
        <ScrollView style={styles.adminContainer} testID={testID}>
            {children}
        </ScrollView>
    );
}

const styleFunc: StyleFunction = (theme, dimensions) => ({
    adminContainer: {
        flex: 1,
        padding: theme.spacingScale * 2,

        // Window height minus appbar height
        maxHeight: dimensions.height - 64,
    },
});
